import { render, staticRenderFns } from "./notification-data-result.view.vue?vue&type=template&id=5221e520&"
import script from "./notification-data-result.view.vue?vue&type=script&lang=ts&"
export * from "./notification-data-result.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports